if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        const initialVariantMediaIds = (this.dataset.variantMediaIds || '')
          .split(',')
          .map((mediaId) => mediaId.trim())
          .filter(Boolean);

        if (initialVariantMediaIds.length) {
          window.requestAnimationFrame(() => this.filterVariantMedia(initialVariantMediaIds));
        }
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      // onSlideChanged(event) {
      //   const thumbnail = this.elements.thumbnails.querySelector(
      //     `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
      //   );
      //   this.setActiveThumbnail(thumbnail);
      // }

       onSlideChanged(event) {
          if (!event.detail || !event.detail.currentElement || !event.detail.currentElement.dataset) {
            return;
          }
          const mediaId = event.detail.currentElement.dataset.mediaId;
          const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveThumbnail(thumbnail);
        }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        this.prioritizeMediaImage(activeMedia);
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        if (!activeThumbnail) return;
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      filterVariantMedia(mediaIds) {
        if (!Array.isArray(mediaIds) || !mediaIds.length) return;

        const allowedMediaIds = new Set(mediaIds.map(String));
        const extractMediaId = (sectionMediaId) => String(sectionMediaId || '').split('-').pop();
        const mediaItems = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]'));
        if (!mediaItems.some((media) => allowedMediaIds.has(extractMediaId(media.dataset.mediaId)))) return;
        let firstVisibleMedia = null;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((media) => {
          const isVisible = allowedMediaIds.has(extractMediaId(media.dataset.mediaId));
          media.classList.toggle('brasslism-variant-media-hidden', !isVisible);
          media.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
          if (isVisible && !firstVisibleMedia) firstVisibleMedia = media;
        });

        if (this.elements.thumbnails) {
          let visiblePosition = 0;
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((thumbnail) => {
            const isVisible = allowedMediaIds.has(extractMediaId(thumbnail.dataset.target));
            thumbnail.classList.toggle('brasslism-variant-media-hidden', !isVisible);
            thumbnail.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
            if (isVisible) {
              visiblePosition += 1;
              thumbnail.dataset.mediaPosition = visiblePosition;
            }
          });

          if (this.elements.thumbnails.swiper) {
            this.elements.thumbnails.swiper.update();
            this.elements.thumbnails.swiper.slideTo(0, 0);
          }
        }

        const visibleMedia = Array.from(
          this.elements.viewer.querySelectorAll('[data-media-id]:not(.brasslism-variant-media-hidden)')
        );
        const currentActive = this.elements.viewer.querySelector(
          '[data-media-id].is-active:not(.brasslism-variant-media-hidden)'
        );

        if (currentActive) this.prioritizeMediaImage(currentActive);
        if (!currentActive && firstVisibleMedia) {
          this.setActiveMedia(firstVisibleMedia.dataset.mediaId, false);
        }

        const total = this.querySelector('.slider-counter--total');
        if (total) total.textContent = visibleMedia.length;
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      prioritizeMediaImage(activeItem) {
        const image = activeItem.querySelector('.product__modal-opener img');
        if (!image) return;
        image.fetchPriority = 'high';
        image.loading = 'eager';
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image || !this.elements.liveRegion) return;
        const announce = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.textContent = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        if (image.complete && image.naturalWidth > 0) {
          announce();
        } else {
          image.addEventListener('load', announce, { once: true });
        }
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

const brasslismVariantMediaStyle = document.createElement('style');
brasslismVariantMediaStyle.textContent =
  '.brasslism-variant-media-hidden{display:none!important;}';
document.head.appendChild(brasslismVariantMediaStyle);

